import { render } from "./MeasureOrganProtectedMarketCard.vue?vue&type=template&id=6ddf4bf7"
import script from "./MeasureOrganProtectedMarketCard.vue?vue&type=script&lang=js"
export * from "./MeasureOrganProtectedMarketCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__